export const ghostLegBoostStatusMap = {
    Original: () => ({ status: "Active", messages: [] }),
    Downgraded: (dictionary) => ({ status: "Inactive", messages: [{ type: "GhostReturned", text: dictionary.myBetsDictionary.GhostLegVoided }] }),
    Returned: (dictionary) => ({ status: "Inactive", messages: [{ type: "GhostReturned", text: dictionary.myBetsDictionary.GhostLegVoided }] }),
    Forfeit: (dictionary, bet) => {
        if (bet.settlementStatus === "CashOut") {
            return { status: "Inactive", messages: [{ type: "Regular", text: dictionary.myBetsDictionary.GhostLegCashout }] };
        }
        if (bet.settlementStatus === "Won") {
            return { status: "Inactive", messages: [{ type: "Regular", text: dictionary.myBetsDictionary.GuaranteedNotNeedIt }] };
        }
        return { status: "Inactive", messages: [] };
    },
    GuaranteedPayoutPending: (dictionary) => ({ status: "Active", messages: [{ type: "Regular", text: dictionary.myBetsDictionary.GhostLegPending }] }),
    GuaranteedPayoutWon: (dictionary) => ({ status: "Active", messages: [{ type: "GhostWin", text: dictionary.myBetsDictionary.GhostLegWin }] }),
    GuaranteedPayoutLost: (dictionary) => ({ status: "Inactive", messages: [{ type: "Regular", text: dictionary.myBetsDictionary.GhostLegNoLongerEligible }] }),
};
export function parseGuaranteedPayoutBonusMessagesAndStatus(bonus, bet, dictionary) {
    const statusKey = bonus.boostStatus;
    const handler = ghostLegBoostStatusMap[statusKey];
    const { status, messages } = (handler === null || handler === void 0 ? void 0 : handler(dictionary, bet)) || { status: "Inactive", messages: [] };
    return [status, messages];
}
//# sourceMappingURL=parseGuaranteedPayoutBonusMessagesAndStatus.js.map